/**
 * The three questions every keyboard handler in the app asks.
 *
 * Shared because getting one of them wrong is invisible until the day you
 * type "1" into a note and get thrown into the first room.
 */

/**
 * Never fire a single-key shortcut while this is true. A description field is
 * full of digits and single letters, and every one of them is text.
 */
export function isTextField(target: EventTarget | null): boolean {
  return (
    target instanceof HTMLElement &&
    target.closest('input, textarea, [contenteditable]') !== null
  );
}

/** Cmd on a Mac, Ctrl everywhere else. The app never distinguishes them. */
export function isMod(event: KeyboardEvent): boolean {
  return event.metaKey || event.ctrlKey;
}

/**
 * A modal is open, so the app behind it isn't listening.
 *
 * `<dialog>.showModal()` makes the background inert to pointers and to focus,
 * but a listener on `document` still hears every key — this is what stops a
 * confirmation dialog from being navigated out from underneath.
 */
export function isBlocked(): boolean {
  return document.querySelector('dialog[open]') !== null;
}
